/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import AppStateContext from '../app/context/appStateContext';

import { TOKEN_EXPIRED, TIMEOUT, INTERNAL_ERROR } from "../hooks/useAPIHelper";

const GET_CONTRACTS_URL = '/.netlify/functions/xServiceGetContracts';

const GetContractDataList = async (token: string, selectedCustomerId: string, filter: string) => {

  const fetchData = async (): Promise<any> => {
    try {
      const contractDataRes = await axios({
        method: 'POST',
        url: GET_CONTRACTS_URL,
        headers: {
          'Content-Type': 'application/xml',
          'X-Pronto-Token': token,
        },
        data: `<Parameters><CustomerCode>${selectedCustomerId}</CustomerCode>${filter}</Parameters>`,
      });

      if (contractDataRes.status === 200) {
        let serviceContracts = contractDataRes.data.XServiceGetContractsResponse.ServiceContracts;
        if (serviceContracts) {
          if(Array.isArray(serviceContracts.ServiceContract)) {
            return serviceContracts.ServiceContract;
          } else {
            return [serviceContracts.ServiceContract];
          }
        } else {
          return [];
        }
      }
    } catch (err) {
      if(err.response.status == 504) {
        throw(TIMEOUT);
      } else if(err.response.status == 401) {
        if(err.response.data == 'TokenExpired') {
          throw(TOKEN_EXPIRED);
        }
      }
    }
  };

  return await fetchData();
};

export default GetContractDataList;
